import { ThemeSubtype, ThemeType } from '@/creditflowresearch/domain/vo/ArticlesAndStats/Articles/themeTypes';
import findKey from 'lodash/findKey';
import DateTime from '@dealroadshow/uikit-date-time';
import { mapSubtype, mapType } from '@/creditflowresearch/ui/components/creditFlow/articles/helpers';
import { IMarketArticlesTabParams } from '@/creditflowresearch/domain/vo/ArticlesAndStats/Articles/IMarketArticle';

export const getTabParams = (articleType: string, productType: string): IMarketArticlesTabParams | undefined => {
  const themeType: ThemeType = findKey(mapType, ({ url }) => url === articleType) as ThemeType;
  const themeSubtype: ThemeSubtype = findKey(mapSubtype, ({ url }) => url === productType) as ThemeSubtype;
  const includedThemeType = themeType && themeType !== ThemeType.all ? themeType : undefined;
  const includedThemeSubtype = themeSubtype && themeSubtype !== ThemeSubtype.all ? themeSubtype : undefined;

  if (!includedThemeType && !includedThemeSubtype) {
    return undefined;
  }

  const tabParams: IMarketArticlesTabParams = {};

  if (includedThemeType) {
    tabParams.includedThemeType = includedThemeType;
  }

  if (includedThemeSubtype) {
    tabParams.includedThemeSubtype = includedThemeSubtype;
  }

  return tabParams;
};

// todo getISODateFromUnix don't use
// todo will need to remove when packages/framework/UI/Organisms/Filters/FiltersPanel/DatePeriod will be rewritten
export const getISODateFromUnix = (date: string | number): string => {
  if (!date) return null;
  return new DateTime(Number(date) * 1000).ISOString;
};
